var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.111,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart-outline_svg__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heart-outline_svg__b)",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.789 1.572a4.562 4.562 0 0 0-7.283.528 7 7 0 0 0-.451.731A7 7 0 0 0 8.6 2.1a4.562 4.562 0 0 0-7.283-.524A5.5 5.5 0 0 0 0 5.218a6.72 6.72 0 0 0 1.852 4.411 41 41 0 0 0 4.634 4.33c.7.6 1.426 1.215 2.2 1.89l.023.02a.53.53 0 0 0 .7 0l.023-.02c.772-.675 1.5-1.293 2.2-1.89a41 41 0 0 0 4.634-4.329 6.72 6.72 0 0 0 1.852-4.411 5.5 5.5 0 0 0-1.321-3.646m-5.86 11.578c-.6.515-1.226 1.045-1.882 1.615-.656-.57-1.277-1.1-1.882-1.615-3.68-3.137-6.112-5.209-6.112-7.933a4.43 4.43 0 0 1 1.056-2.945 3.54 3.54 0 0 1 2.694-1.212 3.58 3.58 0 0 1 2.928 1.648 6.3 6.3 0 0 1 .812 1.615.531.531 0 0 0 1.009 0 6.3 6.3 0 0 1 .812-1.615 3.5 3.5 0 0 1 5.621-.436 4.43 4.43 0 0 1 1.057 2.945c0 2.724-2.432 4.8-6.113 7.933",
    "data-name": "Path 43"
  }))))));
};
export default SvgHeartOutline;